module.exports = __webpack_public_path__ + "static/media/MDSSyllabus.77254889.docx";